import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { greyScaleColors, semanticColors } from '../../../Globals/styles'
import ReactSlider from '../../../Util/react-slider';

class DelegateHoursStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: []
    }
  }
  componentWillMount = () => {
    const { initValues, employee } = this.props;
    //if there is default value, create a defaultvalue object for ReactSlider
    var hoursPerActivity = Math.round((employee.sumHours/employee.activities.length)*2)/2;
    //is only halfs means user cant move the handles
    let defaultValues = [];
    //array used if there is already an older registration;
    let alreadyRegisteredValues = [];
    if(initValues.length){
      let currentSum = 0;
      initValues.forEach((def, index) =>{
        //if its not the last index do stuff
        if(index!==initValues.length -1){
          defaultValues.push(def.hours + currentSum)
          currentSum += def.hours;
        }
      })
    }
    //if there is no initValue calculate defaultValues from routine and activities
    else {
      let alreadyRegistered = 0;
      //create default values if there is an older registration and if it has to calculate new one self
      employee.activities.forEach((activity, index) =>{
        if(index!==employee.activities.length -1){
           defaultValues.push(hoursPerActivity*(index+1))
           alreadyRegisteredValues.push(activity.hours+alreadyRegistered)
        }
        alreadyRegistered += activity.hours;
      });
      if (alreadyRegistered===employee.sumHours){
        defaultValues = alreadyRegisteredValues;
      }
    }
    this.setState({
      defaultValue: defaultValues
    })
  };
  componentDidMount = () => {
    this.handleConflict(this.refs.slider.getValue())
  };
  handleConflict = (values) => {
    const { employee, handleConflict, index } = this.props;
    //if values is not an array, make it
    if(!values.length)
      values = [values]

    let result = []
    let bars = [];

    //map the values to the activities
    employee.activities.forEach((activity, index)=> {

      let hours = 0;
      if(index === 0){
        hours = values[index]
      }
      else if(index === employee.activities.length-1){
        hours = employee.sumHours - values[index-1];
      }
      else{
        hours = values[index] - values[index-1];
      }
      bars.push(hours);
      result.push({
        id: activity.id,
        hours: hours
      })
    });
    //update parrent with solved conflict
    handleConflict(result, index)
    this.getBarChildren(bars);
  };
  getBarChildren = (values) => {
    const { employee, activities } = this.props;
    let result = values.map((val, index)=>{
      return (
        <div style={{
          position:'absolute',
          left:'50%',
          lineHeight: '40px',
          fontSize: '18px',
          fontWeight: '700',
          color: 'white',
          marginLeft: index === 0 ? -15 : ((index*60)-20)}
        }>
          {val}
          <div className="block-with-text" style={styles.activityOnSlider}>
            <span style={styles.activityOnSliderBefore}>...</span>
            {Object.keys(activities).length ? activities[employee.activities[index].id].name : null }
            <span style={styles.activityOnSliderAfter}></span>
          </div>
        </div>
    )})
    this.setState({
      barChildren: result
    })
  };
  render () {
    const { employee } = this.props;
    var handles = [];
    employee.activities.forEach((k, index) => {
      if(index){
        handles.push(
          <div style={[styles.handle, {width: index*60, zIndex: employee.activities.length-index}]} key={k.id}>
            <span style={styles.handleWhiteSpace}></span>
            <i className="fa fa-circle" style={styles.circle}></i>
          </div>)
      }
    });
    return (
      <div>
        <div style={styles.header}>
          <h2 style={styles.heading}>Timefordeling <span style={styles.employeeName}>- {employee.name}</span></h2>
        </div>
        <div style={[styles.sliderContainer, {paddingRight: this.props.employee.activities.length*40}]}>
          <ReactSlider
            ref="slider"
            min={0}
            max={employee.sumHours}
            step={0.5}
            withBars={true}
            pearling={true}
            minDistance={0}
            onChange={(val) => {this.handleConflict(val)}}
            defaultValue={this.state.defaultValue}
            barChildren={this.state.barChildren}
            >
            {handles}
          </ReactSlider>
        </div>
      </div>
    );
  }
}

var styles = {
  header: {
    height: '60px',
    borderBottom: '1px solid ' + greyScaleColors.greyLight
  },
  heading:{
    lineHeight: '60px'
  },
  employeeName:{
    fontWeight: '500'
  },
  handle:{
    height: '40px',
    lineHeight: '51px',
    textAlign: 'right',
    position: 'relative',
    cursor: 'pointer',
    color: semanticColors.primary
  },
  handleWhiteSpace:{
    position: 'absolute',
    right: '9px',
    width: '8px',
    height: '40px',
    backgroundColor: semanticColors.default
  },
  circle:{
    fontSize: '30px',
    position: 'relative'
  },
  sliderContainer:{
    height: '40px',
    backgroundColor: semanticColors.mainBackground,
    width: '100%',
    marginTop: '50px',
    borderRadius: '2px'
  },
  value:{
    display: 'inline-block'
  },
  activityOnSlider: {
    position: 'absolute',
    color: semanticColors.text,
    fontSize: '13px',
    top: '93px',
    transform: 'rotate(32deg)',
    width: '120px',
    overflow: 'hidden',
    lineHeight: '1.2em',
    maxHeight: '2.4em',
    textAlign: 'left',
    marginRight: '-1em',
    paddingRight: '1em'
  },
  activityOnSliderBefore:{
    position: 'absolute',
    right: '0',
    bottom: '0'
  },
  activityOnSliderAfter: {
    content: '',
    position: 'absolute',
    right: '0',
    width: '1em',
    height: '1em',
    marginTop: '0.2em',
    background: semanticColors.default
  }
}
  DelegateHoursStep.propTypes = {
    employee: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      hours: PropTypes.number,
      nightHours: PropTypes.number,
      sumHours: PropTypes.number.isRequired,
      activities: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        hours: PropTypes.number
      })).isRequired,
      absence: PropTypes.shape({
        date: PropTypes.object.isRequired,
        hours: PropTypes.number.isRequired,
        absenceCode: PropTypes.string
      })
    }).isRequired,
    index: PropTypes.number.isRequired,
    handleConflict: PropTypes.func.isRequired,
    initValues: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        hours: PropTypes.number.isRequired
    })),
    activities: PropTypes.object.isRequired
  };
export default Radium(DelegateHoursStep)


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/ConflictWizard/delegateHoursStep.jsx